var path = 'app/components/common/qrCodeScanner/qrCodeScan.html';
var html = "<video id=\"preview\" autoplay class=\"active\" style=\"transform: scaleX(-1);\"></video><section class=\"cameras\"><h2>Pronađene kamere</h2><ul><li ng-if=\"vm.cameras.length === 0\" class=\"empty\">No cameras found</li><li ng-repeat=\"camera in vm.cameras\"><span ng-if=\"camera.id == vm.activeCameraId\" title=\"vm.formatName(camera)\" class=\"active\">{{ vm.formatName(camera) }}</span> <span ng-if=\"camera.id != vm.activeCameraId\" title=\"vm.formatName(camera)\"><a ng-click=\"vm.selectCamera(camera)\">{{ vm.formatName(camera) }}</a></span></li></ul></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/qrCodeScanner/qrCodeScan.html
// module id = 511
// module chunks = 0